import React from "react";
import { Route, Routes } from "react-router-dom-v5-compat";

import { UnitTemplatesHome } from "./UnitTemplatesHome";
import { CalculatorDebugPage } from "./CalculatorDebugPage";

export const UnitTemplates: React.FC = () => (
  <Routes>
    <Route path="debug" element={<CalculatorDebugPage />} />
    <Route path="/*" element={<UnitTemplatesHome />} />
  </Routes>
);
